import z from 'zod'

import { CoercedNumberArraySchema } from '@/legacy-src/schemas/CoercedNumberArraySchema'

export enum SessionTypeFilter {
  ALL = 'all',
  ONLINE = 'online',
  OFFLINE = 'offline',
  HYBRID = 'hybrid',
}

export const SessionTypeFilterSchema = z.nativeEnum(SessionTypeFilter).default(SessionTypeFilter.ALL)
export const SafeSessionTypeFilterSchema = SessionTypeFilterSchema.catch(SessionTypeFilter.ALL)

export const SessionLocationFilterSchema = CoercedNumberArraySchema.default([])
export const SafeSessionLocationFilterSchema = SessionLocationFilterSchema.catch([])
